'use strict';

angular.module('dekky.forms.themes.far')
.run(function($templateCache) {
	$templateCache.put('/dekky.forms/themes/far/row.html',
		'<span style="position: relative;">' +
			'<label for="{{ field.name }}" ng-if="field.label_before" ng-class="field.label_before_class">{{ field.label_before }}</label>' +
			'<form-widget field="field" ng-model="model" ng-disabled="disabled"></form-widget>' +
			'<label for="{{ field.name }}" ng-if="field.label && field.type != \'checkbox\'">{{ field.label }}</label>' +
		'</span>'
	);
});